import { render, staticRenderFns } from "./ConnectivityNotice.vue?vue&type=template&id=72a48d62&"
import script from "./ConnectivityNotice.vue?vue&type=script&lang=js&"
export * from "./ConnectivityNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports